import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import AdminLayout from './components/Admin/AdminLayout'
import AdminSignup from "./components/Admin/AdminSignup";


const AdminDashboard = lazy(() => import("./components/Admin/AdminDashboard"));

function AdminRoutes() {
  return (
    <>
      <Routes>
          <Route path="/" element={<AdminLayout />}>
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Route>
          <Route path="/admin/signup" element={<AdminSignup />} />
       </Routes>

    </>
  );
}

export default AdminRoutes;
